import React from 'react'
import { Stat } from '@arnsbogroup/react-voicearchive'

const StatOutput = ({ descriptor, data }) => (
  <Stat name={descriptor.label} icon={descriptor.icon} data={{ current: data }} />
)

export default StatOutput
